import { render, staticRenderFns } from "./fabricantes.vue?vue&type=template&id=6aa3a23e&scoped=true&"
import script from "./fabricantes.vue?vue&type=script&lang=js&"
export * from "./fabricantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3a23e",
  null
  
)

export default component.exports